import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { publicApi } from '../../services/publicApi';

const Partners = () => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const loadPartners = async () => {
      try {
        const data = await publicApi.getPartners();
        if (!isMounted) return;
        if (!Array.isArray(data) || data.length === 0) {
          setPartners([]);
          return;
        }

        const mapped = data
          .filter((item) => item.isActive !== false)
          .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))
          .map((item) => ({
            id: item.id,
            logo: item.logoUrl,
            name: item.name,
          }));
        setPartners(mapped);
      } catch {
        if (isMounted) setPartners([]);
      }
    };

    loadPartners();
    return () => {
      isMounted = false;
    };
  }, []);

  if (partners.length === 0) return null;

  return (
    <section className="py-20 bg-white dark:bg-[#0a0a0a] transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <div className="text-primary text-sm font-bold tracking-[0.2em] uppercase mb-4">
            Our Partners
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-[#0B132B] dark:text-white mb-4">
            We work with the best partners
          </h2>
          <p className="text-gray-500 dark:text-gray-300 max-w-2xl mx-auto text-lg leading-relaxed">
            We collaborate with leading companies to build digital solutions that drive growth and innovation.
          </p>
        </motion.div>

        <div className="overflow-hidden w-full relative mt-8 py-6">
          <motion.div
            className="flex flex-nowrap w-max items-center gap-16 md:gap-24 pr-16 md:pr-24"
            animate={{ x: ['0%', '-50%'] }}
            transition={{ repeat: Infinity, ease: 'linear', duration: 20 }}
          >
            {[...partners, ...partners].map((partner, idx) => (
              <div
                key={`${partner.id}-${idx}`}
                className="w-32 md:w-40 flex items-center justify-center flex-shrink-0 transition-transform duration-300 transform hover:scale-110"
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="w-full h-auto object-contain max-h-20"
                />
              </div>
            ))}
          </motion.div>

          <div className="absolute top-0 bottom-0 left-0 w-16 md:w-32 bg-gradient-to-r from-white dark:from-[#0a0a0a] to-transparent pointer-events-none z-10"></div>
          <div className="absolute top-0 bottom-0 right-0 w-16 md:w-32 bg-gradient-to-l from-white dark:from-[#0a0a0a] to-transparent pointer-events-none z-10"></div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
